/** ソフトごとのアドオン能力と互換ローダー。 */
const capabilities: Record<string, { mods: boolean; plugins: boolean; loader?: 'fabric' | 'neoforge' | 'forge' }> = {
  velocity: { mods: false, plugins: true },
  vanilla: { mods: false, plugins: false },
  paper: { mods: false, plugins: true },
  purpur: { mods: false, plugins: true },
  folia: { mods: false, plugins: true },
  fabric: { mods: true, plugins: false, loader: 'fabric' },
  neoforge: { mods: true, plugins: false, loader: 'neoforge' },
  forge: { mods: true, plugins: false, loader: 'forge' },
  youer: { mods: true, plugins: true, loader: 'neoforge' },
  asyncyouer: { mods: true, plugins: true, loader: 'neoforge' },
  mohist: { mods: true, plugins: true, loader: 'forge' },
};
export function addonKindsOf(family: string): { mods: boolean; plugins: boolean } {
  const value = capabilities[family];
  return { mods: value?.mods ?? false, plugins: value?.plugins ?? false };
}
export function modLoaderOf(family: string): 'fabric' | 'neoforge' | 'forge' | undefined {
  return capabilities[family]?.loader;
}
export function addonLoaderOf(family: string, kind: 'mod' | 'plugin' = addonKindsOf(family).mods ? 'mod' : 'plugin') {
  return kind === 'mod'
    ? modLoaderOf(family)
    : addonKindsOf(family).plugins
      ? family === 'velocity'
        ? ('velocity' as const)
        : family === 'purpur'
          ? ('purpur' as const)
          : ('paper' as const)
      : undefined;
}
export function addonLabelOf(family: string): string {
  const { mods, plugins } = addonKindsOf(family);
  return mods && plugins ? 'Mod・プラグイン' : plugins ? 'プラグイン' : 'Mod';
}

export function softwareForModpack(
  current: import('./domain.js').SoftwareSpec,
  pack: import('./domain.js').SoftwareSpec,
): import('./domain.js').SoftwareSpec {
  const kinds = addonKindsOf(current.family);
  if (!kinds.mods || !kinds.plugins) return pack;
  if (modLoaderOf(current.family) !== modLoaderOf(pack.family))
    throw new Error('このハイブリッドと Modpack のローダーは互換性がありません');
  return { family: current.family, mcVersion: pack.mcVersion, loaderVersion: pack.loaderVersion };
}

/**
 * Velocity（hub 経由）に置けるソフトと、転送の受け方。Paper 系はソフトの設定で、Fabric は FabricProxy-Lite で受ける。
 * NeoForge・Forge・Youer・Mohist はクライアントが hub との行き来で失敗しやすいので直接つなぐ
 */
export function velocitySupportOf(family: string): 'paper' | 'fabric' | undefined {
  if (family === 'paper' || family === 'purpur' || family === 'folia') return 'paper';
  return family === 'fabric' ? 'fabric' : undefined;
}
/** Velocity 配下の Fabric サーバーに自動で入れる転送用の Mod（Modrinth の FabricProxy-Lite。Fabric API に依存する） */
export const FABRIC_PROXY_PROJECT = {
  projectId: '8dI2tmqs',
  slug: 'fabricproxy-lite',
  title: 'FabricProxy-Lite',
} as const;
